module.exports = __webpack_public_path__ + "1bb12f4f/img/ion_calendar-number.3ac5bd07.svg";